// extracted by mini-css-extract-plugin
module.exports = {"moreOnSiContainer":"_26Enf","innerContainer":"_3MwfB","icon":"_1EvoS","linkListing":"RwSOl","externalLinkButton":"_7lC_Q"};